import ConferenceVenue from "../components/Venue/ConferenceVenue";

export default function Venue() {
    return(
        <main className=" mt-28">
            <ConferenceVenue />
        </main>
    )
}